import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useGiveawayStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/giveaway/stats`);
      setStats(data);
    } catch (e) {
      // keep previous stats on error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { stats, loading, refetch };
};

export { API };
